// ============================================================
// HABIT OS — Bibliothek: Kälte- & Wärme-Therapie
// Cold Plunge · Eisbaden · Sauna · Wechselduschen
// Hormesis · Wissenschaftliche Grundlagen
// ============================================================

export const LIBRARY_COLD_THERAPY = {
  id: "cold_therapy",
  label: "Kälte- & Wärme-Therapie",
  icon: "🧊",
  subcategories: [

    // ── KÄLTETHERAPIE GRUNDLAGEN ─────────────
    {
      id: "cold_basics",
      label: "Kältetherapie Grundlagen",
      icon: "❄️",
      habits: [
        {
          id: "hab_cold_what_happens",
          label: "Was passiert im Körper bei Kälteexposition?",
          time: "flexible",
          icon: "🔬",
          why: "Kältereize aktivieren das Nervensystem; viele fühlen sich danach wach und erfrischt. Bei Herz-Kreislauf-Erkrankungen, Bluthochdruck oder Raynaud-Syndrom vorher ärztlich abklären.",
          source: "Shevchuk et al., Medical Hypotheses, 2008 · Cypess et al., New England Journal of Medicine, 2009",
          dose: "Mit 30 Sek. kaltem Duschen beginnen und langsam steigern. Kaltwasserbäder nie allein und bei Herz-Kreislauf-Erkrankungen nur nach ärztlicher Freigabe.",
        },
        {
          id: "hab_cold_timing",
          label: "Kältetherapie-Timing: Morgens für Energie",
          time: "morning",
          icon: "⚡",
          why: "Morgens ist Kältetherapie am wirkungsvollsten für Energie und Fokus: Der Norepinephrin- und Dopamin-Spike setzt exakt dann ein wenn du ihn brauchst. Abends kann Kältetherapie den Einschlafprozess verzögern (erhöhte Körpertemperatur und Aktivierung). AUSNAHME nach dem Training: Kälte nach Krafttraining kann Muskeladaptation reduzieren — das Signal für Muskelwachstum (Entzündung) wird durch Kälte gedämpft. Kälte nach Ausdauertraining: kein Problem, sogar förderlich.",
          source: "Roberts et al., Journal of Physiology, 2015 · Petersen & Fyfe, Frontiers in Sports and Active Living, 2021",
          dose: "Morgens: Cold Plunge oder Kaltdusche für maximalen Energie-Boost. Nach Krafttraining: mindestens 4–6 Std. warten oder ganz weglassen. Nach Ausdauer: sofort okay.",
        },
      ],
    },

    // ── KALTDUSCHE PROTOKOLL ─────────────────
    {
      id: "cold_shower",
      label: "Kaltdusche Protokoll",
      icon: "🚿",
      habits: [
        {
          id: "hab_cold_shower_beginner",
          label: "Kaltdusche Einsteiger: 30-Sekunden-Methode",
          time: "morning",
          icon: "🚿",
          why: "Die größte Hürde bei Kältetherapie ist der mentale Widerstand. Der Trick: Erst normal duschen, dann in den letzten 30 Sekunden auf kalt umstellen. Das Gehirn protestiert — aber die Entscheidung ist bereits gefallen. Dieser Moment des Unbehagens-Aushalten ist direktes Training des präfrontalen Kortex: Du übst, trotz Stresssignal rational zu handeln. Mit der Zeit verlängern: 30 Sek. → 60 Sek. → 2 Min. → 3 Min. Die Kältetoleranz steigt schnell.",
          source: "Huberman Lab Podcast, 2021 · Brazaitis & Skurvydas, Sports Medicine, 2010",
          dose: "Am Ende der Dusche 30 Sek. kalt und langsam steigern. Bei Herz-Kreislauf-Erkrankungen vorher ärztlich abklären.",
        },
        {
          id: "hab_cold_shower_advanced",
          label: "Kaltdusche Fortgeschritten: Vollständig kalt",
          time: "morning",
          icon: "💪",
          why: "Vollständig kalte Dusche (ohne warmes Wasser vorher) maximiert den Norepinephrin-Spike — der Körper muss sofort reagieren. Atemtechnik ist entscheidend: tiefe, kontrollierte Atemzüge sofort beim Einsteigen verhindert den Panik-Atemreflex ('Gasping'). Physiologischer Seufzer (doppeltes Einatmen, langes Ausatmen) aktiviert Parasympathikus und hilft das Unbehagen zu managen. Diese Fähigkeit — mitten in Stress ruhig zu bleiben — ist trainierbar und transferiert auf alle Lebensbereiche.",
          source: "Tipton, Experimental Physiology, 2012",
          dose: "Nur nach Gewöhnung; ruhig weiteratmen und bei Schwindel sofort abbrechen. Bei Herz-Kreislauf-Erkrankungen vorher ärztlich abklären.",
        },
        {
          id: "hab_cold_contrast",
          label: "Wechseldusche: Heiß-Kalt-Kontrast",
          time: "flexible",
          icon: "♨️",
          why: "Wechselduschen wechseln zwischen warmem und kaltem Wasser; viele empfinden das als belebend. Belastbare Belege für gesundheitliche Effekte sind begrenzt.",
          source: "Bleakley et al., British Journal of Sports Medicine, 2012",
          dose: "3 Min. heiß → 30–60 Sek. kalt → 3 Min. heiß → 30–60 Sek. kalt → Ende mit kalt. 3–4 Runden. Ideal nach dem Training oder morgens.",
        },
      ],
    },

    // ── COLD PLUNGE / EISBADEN ───────────────
    {
      id: "cold_plunge",
      label: "Cold Plunge & Eisbaden",
      icon: "🏊",
      habits: [
        {
          id: "hab_cold_plunge_protocol",
          label: "Cold Plunge: Das optimale Protokoll",
          time: "morning",
          icon: "🧊",
          why: "Ein kurzes Kaltwasserbad ist ein starker Kältereiz. Langzeit-Gesundheitseffekte sind beim Menschen nicht gesichert.",
          source: "Srámek et al., Journal of Applied Physiology, 2000 · Tipton, Experimental Physiology, 2012",
          dose: "Nie allein und nicht nach Alkohol; Einsteiger höchstens 1 Min., Kopf über Wasser, danach warm anziehen. Bei Herz-Kreislauf-Erkrankungen vorher ärztlich abklären.",
        },
      ],
    },

    // ── SAUNA-PROTOKOLL ──────────────────────
    {
      id: "cold_sauna",
      label: "Sauna-Protokoll",
      icon: "🧖",
      habits: [
        {
          id: "hab_sauna_longevity",
          label: "Sauna: regelmäßige Saunagänge",
          time: "flexible",
          icon: "🔥",
          why: "Saunabaden ist eine traditionelle Wärmeanwendung, die als entspannend empfunden wird. Beobachtungsstudien zeigen Zusammenhänge mit Herzgesundheit, belegen aber keine Ursache-Wirkung.",
          source: "Laukkanen et al., JAMA Internal Medicine, 2015 · Laukkanen et al., BMC Medicine, 2018",
          dose: "2–3 Gänge à 8–15 Min. mit Abkühlpausen, ausreichend trinken. Bei Herz-Kreislauf-Erkrankungen oder nach Alkohol verzichten bzw. ärztlich abklären.",
        },
        {
          id: "hab_sauna_growth_hormone",
          label: "Sauna-Gänge mit Pausen",
          time: "flexible",
          icon: "📈",
          why: "Mehrere kürzere Saunagänge mit Abkühlpausen sind für viele gut verträglich. Ausreichend trinken ist wichtig.",
          source: "Leppäluoto et al., Acta Physiologica Scandinavica, 1986 · Kukkonen-Harjula & Kauppinen, Annals of Medicine, 1988",
          dose: "2–3 Gänge à 8–15 Min. mit Abkühlpausen, nicht mit leerem Magen.",
        },
        {
          id: "hab_sauna_mental_health",
          label: "Sauna zur Entspannung",
          time: "flexible",
          icon: "🧠",
          why: "Viele Menschen empfinden Sauna als entspannend. Bei Depressionen ersetzt Sauna keine ärztliche oder psychotherapeutische Behandlung.",
          source: "Janssen et al., JAMA Psychiatry, 2016 · Raison et al., JAMA Psychiatry, 2016",
          dose: "Nach Wohlbefinden 1–3× pro Woche.",
        },
      ],
    },

    // ── HORMESIS ────────────────────────────
    {
      id: "cold_hormesis",
      label: "Hormesis: dosierte Reize",
      icon: "⚖️",
      habits: [
        {
          id: "hab_cold_hormesis_principle",
          label: "Das Hormesis-Prinzip: Was dich nicht tötet...",
          time: "flexible",
          icon: "🌱",
          why: "Hormesis beschreibt die Idee, dass dosierte Reize wie Training, Kälte oder Wärme Anpassungen anstoßen können. Entscheidend ist eine Dosis, die nicht überfordert.",
          source: "Calabrese & Mattson, Trends in Pharmacological Sciences, 2011 · Mattson, Ageing Research Reviews, 2008",
          dose: "Reize dosiert einsetzen und genug Erholung einplanen. Fasten nur nach ärztlicher Abklärung.",
        },
      ],
    },
  ],
};